export const hiText="I'M Harshavardhan";
export const designation="MERN Stack Developer";
export const description='As a Developer always interested to learn new technologies and follow DRY principle for development';